export const ROLE_TYPE = {
  COMPANY: 2,
  REPRESENTATIVE: 3,
  APPLICANT: 4,
};

export const REQUEST_STATUS = {
  ALL: 100,
  ACTION_REQUIRED: 99,
  IN_PROCESS: 1,
  APPROVED: 3,
  EXPIRED: 5,
  FINISHED: 7,
  REJECTED: 8,
  DISMISSED: 9,
  CANCELED: 10,
};
